import { Tabs, Text, VStack } from '@chakra-ui/react';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectActiveGroupsPlatforms } from '@redux/config/config.selectors';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Platform } from '@/types/config/config.types';

import Header from './Header';
import LadSearch from './LadSearch';

export type PlatformSearch = { platform: Platform; active: boolean }[];

export default function Search() {
  const { formatMessage } = useIntl();

  const platforms = useAppSelector(selectActiveGroupsPlatforms);
  const [platformSearch, setPlatformSearch] = useState<PlatformSearch>(
    platforms
      .map((platform) => ({ platform, active: true }))
      .concat({
        platform: {
          id: -1,
          code: '',
          site: '',
          name: formatMessage({ id: 'replay.search.header.withoutPlatform' }),
          altitude: null,
          heightOffset: 0,
          polygon: {
            type: 'Polygon',
            coordinates: [],
          },
          messagingParameters: {
            nfzEntry: {
              enabled: false,
              levels: [],
            },
            nfzExit: {
              enabled: false,
              levels: [],
              delay: 0,
            },
            droneLost: {
              enabled: false,
            },
          },
        },
        active: true,
      }),
  );

  return (
    <VStack gap={0} width="100%" height="100%">
      <Header platforms={platformSearch} onChange={(value) => setPlatformSearch(value)} />
      <Tabs.Root width="100%" height="100%" display="flex" flexDirection="column" defaultValue="lad">
        <Tabs.List>
          <Tabs.Trigger value="lad">
            <Text>
              <FormattedMessage id="replay.search.ladSearch.title" />
            </Text>
          </Tabs.Trigger>
          <Tabs.Trigger value="perim">
            <Text>
              <FormattedMessage id="replay.search.perim" />
            </Text>
          </Tabs.Trigger>
          <Tabs.Trigger value="tech">
            <Text>
              <FormattedMessage id="replay.search.tech" />
            </Text>
          </Tabs.Trigger>
        </Tabs.List>
        <Tabs.ContentGroup>
          <LadSearch
            platforms={platformSearch.filter((platform) => platform.active).map((platform) => platform.platform)}
          />
        </Tabs.ContentGroup>
      </Tabs.Root>
    </VStack>
  );
}
